import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

import { RATING_TARGET_TYPE } from "../detail/detailService";
import { mapPriceBounds, pickList, supplierRatingOf } from "./accessoryMappers";

export const fetchContainerOptions = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.TAXONOMY.containerOptions);

  return pickList(data, "containerOptions");
};

export const fetchProductCategories = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.TAXONOMY.productCategories);

  return pickList(data, "categories", "productCategories");
};

export const fetchContainerMaterials = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.TAXONOMY.containerMaterials);

  return pickList(data, "containerMaterials");
};

export const searchAccessories = async (params) => {
  const { data } = await CLIENT.get(ENDPOINTS.CATALOG.productsSearch, { params });

  return data;
};

export const fetchPriceBounds = async (params) => {
  const { data } = await CLIENT.get(ENDPOINTS.CATALOG.productsSearchBounds, {
    params,
  });

  return mapPriceBounds(data);
};

export const fetchAccessory = async (productId) => {
  const { data } = await CLIENT.get(ENDPOINTS.CATALOG.productById(productId));

  return data;
};

export const fetchSupplierRating = async (supplierId) => {
  const { data } = await CLIENT.get(ENDPOINTS.RATINGS.average, {
    params: { ratedTargetId: supplierId, ratedTargetType: RATING_TARGET_TYPE },
  });

  return supplierRatingOf(data);
};
